import { Dispatch, SetStateAction } from "react";

import { ResponseAnswer } from "~/components/database/detail/database-content/types";
import {
  AnswerInput,
  SpecialWelcomeSaihateContentQuery,
} from "~/lib/graphql/client";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

type Props = {
  form:
    | DatabaseDetailPageProps["form"]
    | SpecialWelcomeSaihateContentQuery["forms"][number];
  responseAnswers: AnswerInput[];
  setResponseAnswers: Dispatch<SetStateAction<AnswerInput[]>>;
  stepToConfirm: () => void;
};

/**
 * @package
 */
export type { Props };

// 与えられた question id ごとに responseAnswer を操作する
// FIXME: これを外に分けたのわかりにくすぎるから直したい author: @funwarioisii
const updateResponseAnswer =
  (
    questionId: number,
    setResponseAnswers: Dispatch<SetStateAction<ResponseAnswer[]>>
  ) =>
  (answer: ResponseAnswer) => {
    setResponseAnswers((prev) => {
      return prev.map((responseAnswer) => {
        if (responseAnswer.questionId === questionId) {
          return answer;
        }
        return responseAnswer;
      });
    });
  };

/**
 * @package
 */
export { updateResponseAnswer };
